import React, { useEffect, useState } from 'react';
import Modal from './Modal';

const ShopStoreButton = ({ href, onClick, text }) => (
  <a className="store-item-footer-btn-shop" onClick={onClick} href={href}>{text}</a>
);

const StoreDetailsButton = ({ href }) => (
  <a className="store-item-footer-btn-store" href={href}>Store Details</a>
);

// const ModalContent = ({ url, fullUrl, closeModal, isModalOpen }) => (
//   <div className="shop-store-modal">
//     <Modal isOpen={isModalOpen} onClose={closeModal}>
//       <h2>Redirection Notice</h2>
//       <p>To shop this store, we will send you to</p>
//       <p>{url}</p>
//       <div className="shop-store-button-footer">
//         <a className="modal-button" href={fullUrl}>Continue</a>
//         <button className="modal-button" onClick={closeModal}>Stay On Page</button>
//       </div>
//     </Modal>
//   </div>
// );

const StoreItem = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [urlsList, setUrlsList] = useState({});
  const [defaultLocation, setDefaultLocation] = useState({});
  const [sisterLocation, setSisterLocation] = useState({});

  useEffect(() => {
    getHoursToday();

    const scriptElement = document.getElementById("gfs-script-js-extra");

    if (scriptElement) {
      const jsCode = scriptElement.textContent.substring(
        scriptElement.textContent.indexOf('/* <![CDATA[ ') + '/* <![CDATA['.length + 3,
        scriptElement.textContent.indexOf('/* ]]> */')
      );
      const jsCode1 = jsCode.substring(jsCode.indexOf('var site_options = ') + 'var site_options = '.length, jsCode.indexOf('var siteParams ='));
      const stringWithoutEscapes = jsCode1.replace(/\\\//g, '/').replace(';', '');
      const jsonParsed = JSON.parse(stringWithoutEscapes);

      setUrlsList(jsonParsed.urls);
      setDefaultLocation(jsonParsed.default_location);
      setSisterLocation(jsonParsed.sister_location);
    }
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const getShopLink = () => {
    const storetype = props.store[1].store_type;
    const redirectUrl = urlsList[defaultLocation]?.homepage;

    let stringCurrentUrl = JSON.stringify(window.location.href);

    // bring up the modal if the store is a grm and the location is the store page
    // if (defaultLocation === "store" && storetype === "grm" || defaultLocation === "grm" && storetype === "store") {
    //   const fullUrl = `${redirectUrl}?dsr_id=${props.store[0]}`;

    //   return (
    //     <>
    //       <ShopStoreButton onClick={openModal} text="Shop This Store" />
    //       <StoreDetailsButton href={props.store[1].permalink} />
    //       <ModalContent url={redirectUrl} fullUrl={fullUrl} closeModal={closeModal} isModalOpen={isModalOpen} />
    //     </>
    //   );
    // } 

    // don't bring up the modal if the store is a grm and the location is the grm page
    if (defaultLocation === "grm" && storetype === "grm") {
      return (
        <>
          <ShopStoreButton href={`${redirectUrl}?dsr_id=${props.store[0]}`} text="Shop This Store" />
          <StoreDetailsButton href={props.store[1].permalink} />
        </>
      );
    }

    // redirect based on the parameters in the url
    if (stringCurrentUrl.includes("?no-store-selected=true&dest=")) {

      let paramString = "";
      let settingsString = "";
      const queryString = stringCurrentUrl.substring(stringCurrentUrl.indexOf("dest"), stringCurrentUrl.length);

      if (queryString.includes("ps%3")) {
        const PSString = queryString.substring(queryString.indexOf("ps%3D") + 5, queryString.length - 1);
        paramString = PSString.replaceAll("%2B", "+");

        if (queryString.includes('&')) {
          settingsString = queryString.substring(queryString.indexOf('&') + 1, queryString.length);

          if (settingsString.length > 5) {
            return (
              <>
                <ShopStoreButton href={`${redirectUrl}?ps=${paramString}&${settingsString}&dsr_id=${props.store[0]}`} text="Shop This Store" />
                <StoreDetailsButton href={props.store[1].permalink} />
              </>
            );
          }
        }

        if (paramString.length > 5) {
          return (
            <>
              <ShopStoreButton href={`${redirectUrl}?ps=${paramString}&dsr_id=${props.store[0]}`} text="Shop This Store" />
              <StoreDetailsButton href={props.store[1].permalink} />
            </>
          );
        }
      }

      return (
        <>
          <ShopStoreButton href={`${redirectUrl}${"?dsr_id=" + props.store[0]}`} text="Shop This Store" />
          <StoreDetailsButton href={props.store[1].permalink} />
        </>
      );
    }

    // final catch all return
    return (
      <>
        <ShopStoreButton href={`${redirectUrl}?dsr_id=${props.store[0]}`} text="Shop This Store" />
        <StoreDetailsButton href={props.store[1].permalink} />
      </>
    );
  };

  const convertTimeFormat = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    let parsedHours = parseInt(hours);
    let period = "am";

    if (parsedHours >= 12) {
      period = "pm";
      if (parsedHours > 12) {
        parsedHours -= 12;
      }
    }

    return `${parsedHours}:${minutes}${period}`;
  };

  const getHoursToday = () => {
    const d = new Date();
    const day = d.getDay();
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const date = d.getDate().toString().padStart(2, '0');
    const dateOverride = `${year}-${month}-${date}`;
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    if (props.store[1].open === "no") {
      return "Coming Soon";
    }

    const matchingHour = props.store[1].hours.find(hour => {
      const startIndex = days.indexOf(hour.start);
      const endIndex = days.indexOf(hour.end);
      return day >= startIndex && day <= endIndex;
    });

    const matchingOverride = Object.keys(props.store[1].hours_override)
      .filter(date => date === dateOverride)
      .map(date => props.store[1].hours_override[date]);

    const matchingClosedDays = props.store[1].closed_days.find(closedDay => {
      const capitalizeClosedDay = closedDay.charAt(0).toUpperCase() + closedDay.slice(1);
      return capitalizeClosedDay.includes(days[day]);
    });

    if (matchingOverride.length > 0) {
      if (matchingOverride[0].closed_all_day === "1") {
        return "Closed";
      } else {
        return `${convertTimeFormat(matchingOverride[0].open_time)} - ${convertTimeFormat(matchingOverride[0].close_time)}`;
      }
    }

    if (matchingHour) {
      return `${matchingHour.open} - ${matchingHour.close}`;
    }

    if (matchingClosedDays) {
      return "Closed";
    }
  };

  const getDefaultStore = () => {
    const cookieView = document.cookie
      .split("; ")
      .find(row => row.startsWith("wp-MyStoreID="))
      ?.split("=")[1];

    if (cookieView === props.store[1].store_id) {
      return <p className="store-item-header-yourStore">Your Store <i className="fa fa-home"></i></p>;
    } else {
      return <p className="store-item-header-miles">{props.distance} mi</p>;
    }
  };

  const buildDrivingInstructions = () => {
    const unformattedAddress = `${props.store[1].address.address_1} ${props.store[1].address.city} ${props.store[1].address.state} ${props.store[1].address.postal_code}`;
    const replaceAddress = unformattedAddress.replace(/ /g, '+');
    return `https://www.google.com/maps/dir/?api=1&destination=Gordon+Food+Service+Store+${replaceAddress}`;
  };

  return (
    <div className="store-item">
      <div className="store-item-header">
        <p className="store-item-header-text no-translate">{props.store[1].name.replace("&#8211;", "-")}</p>
        {getDefaultStore()}
      </div>
      <div className="store-item-details-container">
        <div className="store-item-details-container-text no-translate">
          <p className="store-item-details-container-address">
            <a href={buildDrivingInstructions()} target="_blank" rel="noopener noreferrer">
              {props.store[1].address.address_1} <br />
              {props.store[1].address.city}, {props.store[1].address.state}, {props.store[1].address.postal_code}
            </a>
          </p>
          <a href={`tel:${props.store[1].phone}`} className="store-item-details-container-phone">
            {props.store[1].phone}
          </a>
        </div>
        <div className="store-item-details-hours">
          <div>
            <p className="store-items-details-hours-text-header hours-today">Hours Today:</p>
            <p className="store-items-details-hours-text-header hours-today no-translate">{getHoursToday()}</p>
          </div>
        </div>
      </div>
      <div className="store-item-footer">
        {getShopLink()}
      </div>
    </div>
  );
};

export default StoreItem;
